import Vue from 'vue';
const eventHub = new Vue();
eventHub.lastCategory='осн';
eventHub.isInPosting=false;
export default eventHub;
